const IS_TEST = process.env.REACT_APP_TEST === 'true';

async function jsonReader(path) {
    try {
        let url;
        if (IS_TEST) {
            // Load from local public/data/ in dev mode
            url = `/data/${path}`;
        } else {
            const cb = Math.floor(Date.now() / (1000 * 60 * 5));
            url = `${process.env.REACT_APP_CDN_URL}page_content/${path}?cb=${cb}`;
        }

        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        return await response.json();
    } catch (error) {
        console.error('Error fetching JSON data:', error);
        return null;
    }
}

function getValue(key, data) {
    try { return data[key]; } catch { return key; }
}

function getTimespan(from, to) {
    let tdy = new Date().setHours(0, 0, 0, 0);
    if (from.length !== 0) {
        from = composeDate(from, 'from');
        if (from > tdy) return false;
    }
    if (to.length !== 0) {
        to = composeDate(to, 'to');
        return to > tdy;
    }
    return true;
}

function composeDate(arr, mode) {
    if (mode === 'to') return new Date(arr[2], arr[1] - 1, arr[0]).setHours(0, 0, 0, 0) + 86400000;
    return new Date(arr[2], arr[1] - 1, arr[0]).setHours(0, 0, 0, 0);
}

export { jsonReader, getValue, getTimespan };
